import { render, staticRenderFns } from "./ResourcesCard.vue?vue&type=template&id=b00188d2&scoped=true"
import script from "./ResourcesCard.vue?vue&type=script&lang=js"
export * from "./ResourcesCard.vue?vue&type=script&lang=js"
import style0 from "./ResourcesCard.vue?vue&type=style&index=0&id=b00188d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b00188d2",
  null
  
)

export default component.exports